'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var useInside_esm = require('./use-inside.esm-3f28ebaf.js');

var constants = require('./constants.js');

var index = require('./index-6b8189f0.js');

var ICON_SIZES = new Map([['large', 6 * constants.GU], ['medium', 3 * constants.GU], ['small', 2 * constants.GU], ['tiny', 1.75 * constants.GU]]); // Mapping of button size => icon size

var BUTTON_ICON_SIZES = new Map([['medium', 'medium'], ['small', 'medium'], ['mini', 'small']]);

function useIconSize(size) {
  var _useInside_esm$useIns = useInside_esm.useInside('Button:icon'),
      _useInside_esm$useIns2 = _slicedToArray(_useInside_esm$useIns, 2),
      insideButtonIcon = _useInside_esm$useIns2[0],
      buttonData = _useInside_esm$useIns2[1]; // If no size is set on the icon, and it is inside
  // a Button icon slot, adapt it to the size of the button.


  var sizeName = !size && insideButtonIcon ? BUTTON_ICON_SIZES.get(buttonData.size) : size;
  return ICON_SIZES.get(sizeName || 'medium');
}

var IconPropTypes = {
  size: index.PropTypes.oneOf(['large', 'medium', 'small', 'tiny'])
};
exports.IconPropTypes = IconPropTypes;
exports.useIconSize = useIconSize;